import React from 'react';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import mdEntityService from 'core/metamodel/mdEntityService';
import {BlockComp} from 'core/components/blockComp/blockComp';
import Grid from 'core/grid/domain/grid';
import gridService from 'core/grid/gridService';
import GridComp from 'core/grid/component/gridComp';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {screenLg, tabStyle} from 'core/common/config/variables';
import {ErrorComp} from "core/components/errorComp/errorComp";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {TabTemplate} from "core/common/config/mui-theme";
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {ZzFlatButton} from "core/components/buttons/buttons";
import {observer} from "mobx-react";
import {GridLocation} from "core/grid/domain/grid";
import {MovingBlocks} from "core/grid/gridUtils";
import {ObservableMap, action} from "mobx";
import uiService from "core/common/service/uiService";
import {lovLabel} from "core/form/formUtils";


const gridConfigGridLocation = 'gridConfigList';
const specialConditionGridLocation = 'gridSpecialConditionList';
const fieldGridLocation = "gridLocationFieldList";


@observer
export default class GridLocationDetail extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Grid';
  static icon = 'table';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("GridLocationDetail#fetchData()");

    let gridObjectPromise = gridService.readGridLocation(routerParams.id);

    let gridPromise = gridService.fetchGrids(gridConfigGridLocation, specialConditionGridLocation, fieldGridLocation);

    return Promise.all([gridObjectPromise, gridPromise]).then( ([gridLocationObject, gridLocationMap]:[GridLocation, ObservableMap<GridLocation>]) => {

      gridLocationObject.$movingBlocks = new MovingBlocks(gridConfigGridLocation, true, query.tab,
        new Grid(gridLocationMap.get(gridConfigGridLocation), gridLocationObject.gridLocation),
        new Grid(gridLocationMap.get(specialConditionGridLocation), gridLocationObject.gridLocation),
        new Grid(gridLocationMap.get(fieldGridLocation), gridLocationObject.gridLocation)
      );

      gridService.gridLocationObject = gridLocationObject;
    });
  }



  /**
   *
   */
  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }

  /**
   * tohle je tady kvuli chained detailu
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      gridService.gridLocationObject.$movingBlocks.searchExposedGrids(gridService.gridLocationObject);
    }
  }



  componentDidMount() {
    gridService.gridLocationObject.$movingBlocks.searchExposedGrids(gridService.gridLocationObject);
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    gridService.gridLocationObject = null;
  }




  findRootObject() {
    return gridService.gridLocationObject;
  }

  onSave = (evt) => {
    console.log('onSave');
  };
  onDelete = (evt) => {
    console.log('onDelete');
  };

  onBack = (evt) => {
    console.log('onBack %O', this.context.router);
    this.context.router.transitionTo('gridLocationList');
  };



  render() {


    let {
      query
      } = this.props;


    console.debug('%c GridLocationDetail render query %O', 'background-color: yellow', query);

    let movingBlocks = gridService.gridLocationObject.$movingBlocks;

    const mainForm = (
      <BlockComp style={{marginTop: 10}} header="Grid">
        <form >
          {gridService.gridLocationObject.label} ({gridService.gridLocationObject.gridLocation}) for entity {gridService.gridLocationObject.entityName}
          <br/>
          Security:  {(gridService.gridLocationObject.securable) ? lovLabel(gridService.gridLocationObject.securable): " Unsecured"}
        </form>
      </BlockComp>
    );

    // this.context.router.transitionTo("gridConfigDetail", {id: 'new'}, {gridLocation: this.props.gridObject.gridLocation});
//<FlatButton onClick={this.onClickAdd} label="Vytvořit novou sestavu" securable="gridConfigDetail" permission={PERMISSION.New}/>

    const gridCompArray = [
      <GridComp grid={movingBlocks.getBlock(gridConfigGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(gridConfigGridLocation)} entities={mdEntityService.entityMap}>
        <ZzFlatButtonRoute onGridToolbar routeName="gridConfigDetail" params={{id: 'new'}} query={{gridLocation: gridService.gridLocationObject.gridLocation}} label="New Grid Config" securable="gridConfigDetail" permission={PERMISSION.New}/>
      </GridComp>,
      <GridComp grid={movingBlocks.getBlock(specialConditionGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(specialConditionGridLocation)} entities={mdEntityService.entityMap}>
        <ZzFlatButtonRoute onGridToolbar routeName="gridSpecialConditionDetail" params={{id: 'new'}} query={{gridLocation: gridService.gridLocationObject.gridLocation}} label="New Special Condition" securable="gridSpecialConditionDetail" permission={PERMISSION.New}/>
      </GridComp>,
      <GridComp grid={movingBlocks.getBlock(fieldGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(fieldGridLocation)} entities={mdEntityService.entityMap} />
    ];

    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.gridLocation}  value={gridComp.props.grid.gridLocation}>
        {gridComp}
      </Tab>
    ));

    const tabs = (tabArray.length) ? (
      <Tabs value={gridService.gridLocationObject.$movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange}>
        {tabArray}
      </Tabs>
    ) : '';

    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}} >
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(gridService.gridLocationObject, query.gridLocation)}
            <ErrorComp messages={gridService.gridLocationObject.$errors} />
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          {this._createToolMenu(gridService.gridLocationObject, query.gridLocation)}
          <ErrorComp messages={gridService.gridLocationObject.$errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }


  _createToolMenu(gridObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={false} activeTab={gridObject.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave} label="Save Grid" permission={PERMISSION.Update}/>

      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/gridLocationDetail.tsx